import styles from './Shops.module.scss'
import { motion } from "framer-motion"
import address from '../../image/Map/address.svg'
import phone from '../../image/Map/phone.svg'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5}
    } 
}

const Shops = () => {

    return (
        <motion.section 
            className={styles.main}
            id='magaziny' 
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.02, once: true}}
            >
                <div className={styles.box}>
                    <motion.h2 className={styles.title} variants={titleAnimation}>Партнеры в регионах</motion.h2>
                    <ul className={styles.list}>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            
                            >
                            <p className={styles.item_title}>В Южном Федеральном Округе</p>    
                            <p className={styles.item_title}>ООО ТД УПАКМАРКЕТ</p>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={address} alt = 'icon'/>
                                <p className={styles.text}>г.Краснодар, ул. Кирпичная, 12/2</p>
                            </div>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone} >+7 (861) 200-25-91 </a>
                            </div>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone} >+7 (918) 241-08-08 </a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            
                            >
                            <p className={styles.item_title}>В Центральном Черноземье</p>     
                            <p className={styles.item_title}>ООО ПТФ ПАКМАРКЕТ</p>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={address} alt = 'icon'/>
                                <p className={styles.text}>Тамбовская обл., Тамбовский р-н, с. Донское, Промышленная 13</p>
                            </div>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone}>+7 (4752) 55-95-91</a>
                            </div>
                            <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone}>+7 (4752) 55-96-91</a>
                            </div>
                        </motion.li>
                    </ul>
                    
                </div>
        </motion.section>
        
    )
}

export default Shops